<mat-card appearance="outlined">
    <mat-card-title>
        "Add New Purchase Order Details for Po: {{purchaseOrderDetail.poNumber}}"
    </mat-card-title>
    <mat-card-content>
        <div class="row" style="margin: 5px;border: 1px solid">
            <form [formGroup]="addMorePurchaseOrderDetailForm">
                <div class="row">
                    <div class="col-md-12">
                        <mat-accordion formArrayName="PurchaseOrderDetails">
                            <mat-expansion-panel
                                *ngFor="let item of addMorePurchaseOrderDetailForm.get('PurchaseOrderDetails')['controls'];let i=index;first as isFirst"
                                [formGroupName]="i" [expanded]="isFirst">
                                <mat-expansion-panel-header>
                                    <mat-panel-title><mat-icon>apps</mat-icon>#{{i + 1}}</mat-panel-title>
                                    <mat-panel-description></mat-panel-description>
                                </mat-expansion-panel-header>
                                <div class="row">
                                    <div class="col-md-4">
                                        <mat-form-field color="accent">
                                            <mat-label>Product</mat-label>
                                            <mat-select  formControlName="productId"
                                                (selectionChange)="onProductSelectionchange($event)">
                                                <mat-option [value]="null">Select an option</mat-option>
                                                <mat-option *ngFor="let pr of productOptions; let i = index;"
                                                    [value]="pr.productId">
                                                    {{pr.productName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-form-field color="accent">
                                            <mat-label>Product Category</mat-label>
                                            <mat-select  formControlName="categoryId"
                                                (selectionChange)="onCategorySelectionchange($event)">
                                                <mat-option [value]="null">Select an option</mat-option>
                                                <mat-option *ngFor="let cat of categoryOptions; let i = index;"
                                                    [value]="cat.categoryId">
                                                    {{cat.productCategoryName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-form-field color="accent">
                                            <mat-label>Product Sub Category</mat-label>
                                            <mat-select formControlName="subcategoryId">
                                                <mat-option [value]="null">Select an option</mat-option>
                                                <mat-option *ngFor="let sub of subCategoryOptions; let i = index;"
                                                        [value]="sub.subCategoryId">
                                                             {{ sub.subCategoryName }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <mat-form-field color="accent">
                                            <mat-label>Brand</mat-label>
                                            <mat-select formControlName="brandId">
                                                <mat-option [value]="null">Select an option</mat-option>
                                                <mat-option *ngFor="let br of brandOptions; let i = index;"
                                                    [value]="br.brandId">
                                                    {{br.brandName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field color="accent">
                                            <mat-label>Order Qty</mat-label>
                                            <input matInput type="number"  formControlName="orderQuantity" min="1">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field color="accent">
                                            <mat-label>Warranty In Months</mat-label>
                                            <input matInput type="number" name="warrantyInMonths" id="warrantyInMonths"
                                                formControlName="warrantyInMonths">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field *ngIf="measuringOptions.length > 0" color="accent">
                                            <mat-label>UOM</mat-label>
                                            <mat-select formControlName="measuringUnitId">
                                                <mat-option [value]="null">Select an option</mat-option>
                                                <mat-option *ngFor="let unit of measuringOptions; let i = index;"
                                                    [value]="unit.measuringUnitId">
                                                    {{unit.unitName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-form-field color="accent">
                                            <mat-label>Unit Price</mat-label>
                                            <input matInput type="number" name="unitPrice"
                                                id="unitPrice" formControlName="unitPrice">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1 text-center">
                                        <button mat-fab type="button" (click)="onRemoveItem(i)" [disabled]="i==0">
                                            <mat-icon>remove_from_queue</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions align="end" style="margin:5px;">
         <button mat-raised-button type="button"  style="--btn-width: 50px; --btn-mr: 15px" class="custom-btn"
            (click)="saveMorePurchaseOrderDetails()" matTooltip="Save Child Purchase Order"
            [disabled]="!addMorePurchaseOrderDetailForm.valid || this.measuringOptions.length == 0 || !isAdminGroupUser">
            <span class="mat-mdc-button-wrapper">
                <i class="material-icons" style="font-size: 30px">save</i>
            </span>
        </button>
        <button mat-raised-button color="accent" type="button" (click)="addItem()" class="custom-btn" [disabled]="!isAdminGroupUser"
              matTooltip="Add More Purchase Order Details"  style="--btn-width: 50px; --btn-mr: 25px"
            [disabled]="!addMorePurchaseOrderDetailForm.valid">
            <span class="mat-mdc-button-wrapper">
                <i class="material-icons" style="font-size: 30px">queue</i>
            </span>
        </button>
         <button mat-raised-button color="accent" type="button" (click)="goBackClick()"  
           class="closeBtnForMore"  matTooltip="Close Form.">
            <span class="mat-mdc-button-wrapper">
                <i class="material-icons" style="font-size: 30px">close</i>
            </span>
        </button>
    </mat-card-actions>
    <mat-card-footer>
    </mat-card-footer>
</mat-card>